import makeStyles from "utils/makeStyles";

export default makeStyles(theme => ({
    wrapper: {

    },
    header: {
        padding: "10px 20px",
    },
    toolbar: {
        padding: "10px 20px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    crudButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    content: {
        padding: "10px",
        display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center'
    },
    field:{
        margin: "10px",
        width: '94%',
        maxWidth: "300.8px",
    },
    formButton:{
        width: '45%',
    marginLeft: '11px'
    },
    addButton:{
        width: 'calc(100% - 1rem)',
        marginBottom: '0.5rem',
        marginLeft: '0.5rem',
    },
    deleteButton: {
        position: 'absolute',
        top: -8,
        right: -8,
    },
}));
